import Chip from '@material-ui/core/Chip';
import styled from 'styled-components';

export const StyledChip = styled(Chip)`
    overflow: hidden;
    margin-left: 8px;
`;
